import React from 'react'
import CategoriaCabecera from './CategoriaCabecera'

function CategoriasCabecera({ categoriasArray, categoriaSeleccionada, setCategoriaSeleccionada, menuAbierto, setDesplegar }) {
  return (
    menuAbierto ?
    <div className='w-full shadow-xl mb-4'>
      <ul className='flex w-full flex-col text-xl p-2 items-start text-start'>
        {categoriasArray.map(c => {
          return <CategoriaCabecera setDesplegar={setDesplegar} menuAbierto={menuAbierto} categoria={c} categoriaSeleccionada = {categoriaSeleccionada} setCategoriaSeleccionada={setCategoriaSeleccionada} contenido={c.nombre}/>
        })}
    </ul>
</div>
      :
    <div className='hidden md:flex md:w-full md:h-12 md:bg-GrisClaro'>
      <ul className='hidden md:w-full md:flex md:justify-evenly md:h-full'>
        {categoriasArray.map(c => {
          return <CategoriaCabecera categoria={c} categoriaSeleccionada = {categoriaSeleccionada} setCategoriaSeleccionada={setCategoriaSeleccionada} contenido={c.nombre}/>
        })}
    </ul>
</div>
  )
}

export default CategoriasCabecera